import { useEffect } from "react";

export default function Modal({ children, className = "", onClose, showCloseButton = true }) {
  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [onClose]);

  return (
    <div className="fy-modal-overlay" onClick={() => onClose?.()}>
      <div
        className={`fy-modal ${className}`.trim()}
        role="dialog"
        aria-modal="true"
        onClick={(event) => event.stopPropagation()}
      >
        {showCloseButton ? (
          <button type="button" className="fy-close fy-modal-close" onClick={() => onClose?.()} aria-label="Close modal">
            ✕
          </button>
        ) : null}
        {children}
      </div>
    </div>
  );
}
